import { BASE_URL } from "../../utils/EmpUtil";
import axios from "axios";
import { is401 } from "../../errors/ErrorConstants";
import AuthenticationFailureHandler from "../../utils/AuthenticationFailureHandler";
import { getHeaders } from "../../utils/AuthorizationUtil";

export default class NscEmailNotificationsClient {
  static baseUrl = BASE_URL;

  static getNscEmailNotificationsData(user, market) {
    const url = `${this.baseUrl}/nsc/notifications/get/${market}`;

    return axios
      .get(url, getHeaders(user.token))
      .then((response) => {
        return Promise.resolve(response.data);
      })
      .catch((error) => {
        if (is401(error)) {
          AuthenticationFailureHandler.execute();
        }
        return Promise.reject(error);
      });
  }

  static addNscContactInfo(user, nsc) {
    const url = `${this.baseUrl}/nsc/notifications/add`;

    return axios
      .post(url, nsc, getHeaders(user.token))
      .then((response) => {
        return Promise.resolve(response.data);
      })
      .catch((error) => {
        if (is401(error)) {
          AuthenticationFailureHandler.execute();
        }
        return Promise.reject(error);
      });
  }

  static deleteNscContactInfo(user, nscId) {
    const url = `${this.baseUrl}/nsc/notifications/delete/${nscId}`;

    return axios
      .delete(url, getHeaders(user.token))
      .then((response) => {
        return Promise.resolve(response.data);
      })
      .catch((error) => {
        if (is401(error)) {
          AuthenticationFailureHandler.execute();
        }
        return Promise.reject(error);
      });
  }

  static updateNscEmailNotifications(user, employee, receiveEmails) {
    const url = `${this.baseUrl}/nsc/notifications/update/receiveNotificationEmails/${employee.id}`;
    const nscId = employee.id;

    return axios
      .put(
        url,
        { receiveEmails: receiveEmails, nscId: nscId },
        getHeaders(user.token)
      )
      .then(() => {
        return Promise.resolve();
      })
      .catch((error) => {
        if (is401(error)) {
          AuthenticationFailureHandler.execute();
        }
        return Promise.reject(error);
      });
  }

  static updateNscPriceChangeEmailNotifications(user, employee, receiveEmails) {
    const url = `${this.baseUrl}/nsc/notifications/update/receivePriceChangeEmails/${employee.id}`;
    const nscId = employee.id;

    return axios
      .put(
        url,
        { receiveEmails: receiveEmails, nscId: nscId },
        getHeaders(user.token)
      )
      .then(() => {
        return Promise.resolve();
      })
      .catch((error) => {
        if (is401(error)) {
          AuthenticationFailureHandler.execute();
        }
        return Promise.reject(error);
      });
  }

  static updateNscNameAndEmailAddress(user, nsc) {
    const url = `${this.baseUrl}/nsc/notifications/update/contact`;

    return axios
      .put(url, nsc, getHeaders(user.token))
      .then((response) => {
        return Promise.resolve(response.data);
      })
      .catch((error) => {
        if (is401(error)) {
          AuthenticationFailureHandler.execute();
        }
        return Promise.reject(error);
      });
  }
}
